import React, { useState, useEffect } from 'react';
import Icon from '@components/Icon/Icon';
import { faWifi, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import './NetworkStatus.scss';

const NetworkStatus = ({ showWhenOnline = false, className = '' }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    const handleNetworkStatus = (event) => {
      const online = event.detail.online;
      setIsOnline(online);

      // Show status briefly when network changes
      setShowStatus(true);
      const timer = setTimeout(() => {
        setShowStatus(false);
      }, 3000);

      return () => clearTimeout(timer);
    };

    window.addEventListener('network-status', handleNetworkStatus);

    return () => {
      window.removeEventListener('network-status', handleNetworkStatus);
    };
  }, []);

  // Don't show if online and showWhenOnline is false, unless status just changed
  if (isOnline && !showWhenOnline && !showStatus) {
    return null;
  }

  return (
    <div className={`network-status ${isOnline ? 'online' : 'offline'} ${showStatus ? 'visible' : ''} ${className}`}>
      <Icon
        icon={isOnline ? faWifi : faExclamationTriangle}
        className="network-icon"
      />
      <span className="network-text">
        {isOnline ? 'Back online' : 'No internet connection'}
      </span>
    </div>
  );
};

export default NetworkStatus;
